import React, { useContext } from 'react';
import { useActor } from '@xstate/react';
import { GlobalStateContext } from '../../state/app';
import classNames from 'classnames';

const CloudSyncStatus = () => {
  const globalServices = useContext(GlobalStateContext);
  const [appState] = useActor(globalServices.appState);

  const noteSyncStatuses = appState.context?.noteSyncStatuses ?? {};
  const statusValues = Object.values(noteSyncStatuses);
  const isSaving = statusValues.includes('saving');
  const hasPending = !isSaving && statusValues.includes('pending');
  const isLive = !isSaving && !hasPending;

  let label, dotClass;
  if (isSaving) {
    label = 'Syncing…';
    dotClass = 'syncing';
  } else if (hasPending) {
    label = 'Pending';
    dotClass = 'pending';
  } else {
    label = 'Live';
    dotClass = 'live';
  }

  const title = hasPending
    ? 'Some notes have unsaved changes — they will sync automatically'
    : undefined;

  return (
    <div className="cloud-sync-status" title={title}>
      <span className="cloud-sync-label">CLOUD SYNC</span>
      <div className="cloud-sync-indicator">
        <span className={classNames('status-dot', dotClass)}></span>
        <span className="status-text">{label}</span>
      </div>
    </div>
  );
};

export default CloudSyncStatus;
